import { render } from "./MuseumPage.vue?vue&type=template&id=7288633e"
import script from "./MuseumPage.vue?vue&type=script&lang=js"
export * from "./MuseumPage.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__